import React from "react";
import { BottomNav } from "../../Common/custom_components/bottom_nav/BottomNav";
import { useNotificationsModule } from "./hooks/notifications_module.hook";
import style from "./notifications.module.css";

const GROUPS: { key: "today" | "yesterday" | "older"; label: string }[] = [
  { key: "today", label: "Today" },
  { key: "yesterday", label: "Yesterday" },
  { key: "older", label: "Earlier" },
];

export const DoctorNotifications: React.FC = () => {
  const {
    isLoading,
    notifs,
    unreadCount,
    todayHistoryItems,
    hasUnreadToday,
    incomingRequest,
    countdown,
    handleMarkAllRead,
    handleAccept,
    handleReject,
    markNotificationAsRead,
    navigate,
  } = useNotificationsModule();

  return (
    <div className={style.doctorBody}>
      {/* Header */}
      <div className={style.docHeader}>
        <div className={style.docHeaderLeft}>
          <img
            src="/logo-transparent3.png"
            alt="Pococare"
            style={{ height: "56px" }}
            onError={(e) => {
              (e.target as HTMLImageElement).src =
                "https://nice-stone-091e25e00.3.azurestaticapps.net/logo-transparent3.png";
            }}
          />
          <div className={style.docHeaderInfo} style={{ marginLeft: "12px" }}>
            <h1>Notifications</h1>
            <span>{unreadCount} unread</span>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className={style.notifList} style={{ paddingBottom: "100px" }}>
        {isLoading ? (
          <div style={{ textAlign: "center", padding: "40px", color: "var(--primary)", fontWeight: 600 }}>
            Loading...
          </div>
        ) : (
          <>
            {/* Today group */}
            {(incomingRequest || todayHistoryItems.length > 0) && (
              <div>
                <div className={style.dateRow}>
                  <span className={style.dateLabel}>Today</span>
                  {hasUnreadToday && (
                    <button className={style.markAllBtn} onClick={handleMarkAllRead}>Mark all read</button>
                  )}
                </div>

                {/* Incoming request card */}
                {incomingRequest && (
                  <div className={`${style.notifItem} ${style.unread}`} style={{ flexDirection: "column", gap: "10px" }}>
                    <div style={{ display: "flex", alignItems: "flex-start", gap: "12px", width: "100%" }}>
                      <div className={`${style.notifIcon} ${style.request}`}>
                        <span className="material-icons-round">videocam</span>
                      </div>
                      <div className={style.notifBody}>
                        <div className={style.notifTitle}>New Consultation Request</div>
                        <div className={style.notifDesc}>
                          {incomingRequest.patient_name} • Emergency • {incomingRequest.consultation_mode || "Video"} Call
                        </div>
                        <div className={style.notifTime}>
                          <span className="material-icons-round">schedule</span>
                          Auto-declining in {countdown}s
                        </div>
                      </div>
                      <div className={style.unreadDot} />
                    </div>
                    <div className={style.requestActions}>
                      <button className={style.btnAccept} onClick={handleAccept}>
                        <span className="material-icons-round" style={{ fontSize: "18px" }}>check</span>
                        Accept
                      </button>
                      <button className={style.btnReject} onClick={handleReject}>
                        <span className="material-icons-round" style={{ fontSize: "18px" }}>close</span>
                        Reject
                      </button>
                    </div>
                  </div>
                )}

                {todayHistoryItems.map((item) => (
                  <div
                    key={item.id}
                    className={`${style.notifItem} ${item.unread ? style.unread : ""}`}
                    onClick={() => {
                      markNotificationAsRead(item.id);
                      navigate(`/consultation/${item.id}/detail`);
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <div className={`${style.notifIcon} ${style[item.type]}`}>
                      <span className="material-icons-round">{item.icon}</span>
                    </div>
                    <div className={style.notifBody}>
                      <div className={style.notifTitle}>{item.title}</div>
                      <div className={style.notifDesc}>{item.desc}</div>
                      <div className={style.notifTime}>
                        <span className="material-icons-round">schedule</span> {item.time}
                      </div>
                    </div>
                    {item.unread && <div className={style.unreadDot} />}
                  </div>
                ))}
              </div>
            )}

            {/* Yesterday + Earlier */}
            {GROUPS.filter((g) => g.key !== "today").map(({ key, label }) => {
              const items = notifs.filter((n) => n.day === key);
              if (items.length === 0) return null;
              return (
                <div key={key}>
                  <div className={style.dateRow}>
                    <span className={style.dateLabel}>{label}</span>
                  </div>
                  {items.map((item) => (
                    <div
                      key={item.id}
                      className={style.notifItem}
                      onClick={() => {
                        markNotificationAsRead(item.id);
                        navigate(`/consultation/${item.id}/detail`);
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      <div className={`${style.notifIcon} ${style[item.type]}`}>
                        <span className="material-icons-round">{item.icon}</span>
                      </div>
                      <div className={style.notifBody}>
                        <div className={style.notifTitle}>{item.title}</div>
                        <div className={style.notifDesc}>{item.desc}</div>
                        <div className={style.notifTime}>
                          <span className="material-icons-round">schedule</span> {item.time}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              );
            })}

            {notifs.length === 0 && !incomingRequest && (
              <div style={{ textAlign: "center", padding: "40px", color: "var(--placeholder)" }}>
                No notifications yet.
              </div>
            )}
          </>
        )}
      </div>

      <BottomNav notifBadge={incomingRequest ? 1 : 0} />
    </div>
  );
};
